import React, { useMemo } from 'react';
import Head from 'next/head';
import styled from 'styled-components';
import { useRouter } from 'next/router';
import BreadcrumbArrow from '@/public/images/ackodrive/BreadCrumbArrow.svg';

type ListElement = {
    displayName: string;
    link: string;
};

type breadCrumbsProps = {
    list: ListElement[];
};

export default function Breadcrumbs({ list }: breadCrumbsProps) {
    const router = useRouter();
    const breadcrumbJSONLd = useMemo(
        () => ({
            '@context': 'https://schema.org/',
            '@type': 'BreadcrumbList',
            itemListElement: list?.map((l: ListElement, i: number) => ({
                '@type': 'ListItem',
                position: i + 1,
                name: l?.displayName,
                item: l?.link,
            })),
        }),
        []
    );

    return (
        <BreadcrumbsV2Wrapper>
            <Head>
                <script
                    type="application/ld+json"
                    dangerouslySetInnerHTML={{
                        __html: JSON.stringify(breadcrumbJSONLd),
                    }}
                />
            </Head>
            <Wrapper>
                {list?.map((l: ListElement, index: number) => (
                    <PageName
                        onClick={(event) => {
                            event.preventDefault();
                            router.push(`${l?.link}`);
                        }}
                        key={index}
                        href={l?.link}
                        isLast={index === list.length - 1}
                    >
                        {l?.displayName}
                        {index < list.length - 1 && <BreadcrumbArrowWrapper />}
                    </PageName>
                ))}
            </Wrapper>
        </BreadcrumbsV2Wrapper>
    );
}

export const BreadcrumbsV2Wrapper = styled.div`
    display: flex;
    padding: 20px 16px;
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
`;

export const Wrapper = styled.div`
    display: flex;
    & > a:last-child {
        cursor: default;
    }
`;

export const PageName = styled.a<{
    isLast: boolean;
}>`
    text-decoration: none;
    display: flex;
    align-items: center;
    cursor: pointer;
    color: #4b4b4b;
    ${({ isLast }) => isLast && `pointer-events:none`};
    font-family: 'Euclid Circular B';
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 18px;
`;

export const BreadcrumbArrowWrapper = styled(BreadcrumbArrow)`
    margin: 8px;
    path {
        fill: #757575;
    }
`;
